import request from '@/service/request'


export function getMessages(data) {
    return request({
        url: '/sdpt/get_messages',
        method: 'get',
        data,
    })
}

export function stopMessages(data) {
    return request({
        url: '/sdpt/message_stop',
        method: 'put',
        data,
    })
}

export function getNewMessages(data) {
    return request({
        url: '/sdpt/get_new_messages',
        method: 'get',
        data,
    })
}

export function sendMessage(data) {
    return request({
        url: '/sdpt/message',
        method: 'post',
        data,
    })
}


export function delMessage(data) {
    return request({
        url: '/sdpt/message',
        method: 'delete',
        data,
    })
}

export function delAllMsg(data) {
    return request({
        url: '/sdpt/delAllMsg',
        method: 'post',
        data,
    })
}

export function clear(data) {
    return request({
        url: '/sdpt/clear',
        method: 'put',
        data,
    })
}

export function getResp(data) {
    return request({
        url: '/sdpt/get_resp',
        method: 'get',
        data,
    })
}

export function getUser(data) {
    return request({
        url: '/sdpt/user',
        method: 'get',
        data,
    })
}

export function logout(data) {
    return request({
        url: '/sdpt/logout',
        method: 'put',
        data,
    })
}
